import React, { useContext, useEffect, useState } from 'react';
export const useMIDIContext = () => {
    const context = React.useContext(MIDIContext);
    if (context == null) {
        throw new Error('useMIDIContext must be used within a MIDIContextProvider');
    }
    return context;
};
export const MIDIContext = React.createContext(null);
export function MIDIContextProvider({ children }) {
    if (useContext(MIDIContext) != null) {
        throw new Error('MIDIContextProvider can only be used once');
    }
    const [midiAccess, setAccess] = useState();
    const [inputs, setInputs] = useState(new Map());
    const [outputs, setOutputs] = useState(new Map());
    useEffect(() => {
        if (midiAccess) {
            const updateInputs = () => {
                setInputs(midiAccess.inputs);
            };
            midiAccess.addEventListener('statechange', updateInputs);
            return () => {
                midiAccess.removeEventListener('statechange', updateInputs);
            };
        }
    }, [midiAccess]);
    useEffect(() => {
        if (midiAccess) {
            const updateOutputs = () => {
                setOutputs(midiAccess.outputs);
            };
            midiAccess.addEventListener('statechange', updateOutputs);
            return () => {
                midiAccess.removeEventListener('statechange', updateOutputs);
            };
        }
    }, [midiAccess]);
    useEffect(() => {
        if (hasMIDISupport) {
            navigator
                .requestMIDIAccess({ sysex: true }) // warning: {sysex: true} asks for permission to access MIDI devices
                .then(a => {
                setAccess(a);
                setInputs(a.inputs);
                setOutputs(a.outputs);
            })
                .catch(e => console.error(e));
            return () => {
            };
        }
    }, []);
    return React.createElement(MIDIContext.Provider, { value: { midiAccess, hasMIDISupport, inputs, outputs } }, children);
}
export const hasMIDISupport = Boolean(typeof navigator !== 'undefined' && navigator && navigator.requestMIDIAccess);
//# sourceMappingURL=MIDIContext.js.map